import Input from "../components/input";
import Button from "../components/button";
import colors from "../components/colors";
import Modal from "../components/modal";
import { useState } from "react";
import api from "../utils/api";
import { Link } from "react-router-dom";

const Home = () => {

    const [openRegister, setOpenRegister] = useState(false);
    const [loadingRegister, setLoadingRegister] = useState(false);
    const [name, setName] = useState();
    const [cnpj, setCnpj] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [token, setToken] = useState();

    const handleRegister = () => {

        setLoadingRegister(true);

        api.post('/register', {
            email,
            cnpj,
            name,
            password
        })
        .then(res => {
            setToken(res.data.token);
            setOpenRegister(true);
            setLoadingRegister(false);
        })
        .catch(err => {
            setLoadingRegister(false);
        })

    }

    return (
        <>
            <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 110px)' }}>
                <div className="w-full max-w-xl mx-auto p-4">

                    <h1 className="text-3xl font-bold text-center mb-4">Faça o <span style={{ color: colors?.primary }}>split</span> dos seus pagamento de forma fácil e privada!</h1>
                    
                    <p className="text-lg text-center mb-4">
                        Com maior efeciência tributária
                    </p>

                    <div className="mb-4">
                        <Input
                            fullWidth
                            label="Nome"
                            type="text"
                            placeholder="Seu nome"
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <Input
                            fullWidth
                            label="CNPJ"
                            type="cnpj"
                            placeholder="CNPJ empresa"
                            value={cnpj}
                            onChange={(e) => {
                                setCnpj(e.target.value);
                            }}
                        />
                    </div>

                    <div className="mb-4">
                        <Input
                            fullWidth
                            label="E-mail"
                            type="email"
                            placeholder="Seu e-mail"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                        />
                    </div>
                        
                    <div className="mb-4">
                        <Input 
                            fullWidth
                            label="Senha"
                            type="password"
                            placeholder="Sua senha"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />
                    </div>
                        
                    <Button 
                        isLoading={loadingRegister}
                        onClick={handleRegister}
                        disabled={!name || !cnpj || !email || !password}
                        fullWidth
                    >
                        Cadastrar
                    </Button>

                </div>
            </div>

            <Modal
                isOpen={openRegister}
                disabledClose={true}
                title="Conta criada com sucesso"
            >
                <h6>Conta criada com sucesso!</h6>
                <p>Agora faça seu login</p>
                <br />
                <Link to="/login">
                    <Button>Ir para login</Button>
                </Link>
            </Modal>
        </>
    );
};

export default Home;
